import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	// 12
	render() {
		const style = {
			st155: {
				fill: '#F96E6E',
			},
			st156: {
				fill: '#F26161',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="0.509522" cy="35.2435722" r="0.2505777" />
				<path style={style.st155} d="M88.3330154,43.6074257c-2.4673615,7.1922417-6.3909378,13.9099846-9.6233597,15.5329437
					c-5.0317459,2.5135956-17.8172874-6.7758522-24.1167564-13.5642891c-1.5094185-1.624836-2.6423721-3.1015892-3.2134666-4.2452202
					c-2.9638405-5.9330482-0.5160217-14.7127209,5.9924088-17.9555817c1.2376556-0.6182671,3.020359-1.1892929,5.1256866-1.6526508
					c9.0299683-1.9976215,24.0282516-2.0931835,27.2475662,4.351284
					C91.6538849,29.8949356,90.6189041,36.9597816,88.3330154,43.6074257z" />
				<path style={style.st155} d="M37.7143211,36.6247215c-1.2376518,0.6182671-3.0201111,1.1893768-5.1254349,1.6527328
					c-9.0302143,1.9975395-24.0284977,2.0931015-27.247818-4.351368c-1.9087849-3.821022-0.8737249-10.8861141,1.4053502-17.5469799
					c2.46769-7.1924057,6.3878207-13.899806,9.6300907-15.519475c5.031744-2.513597,17.8172894,6.7758522,24.1170025,13.5643692
					c1.5094185,1.6248369,2.642128,3.1015081,3.2132225,4.2451372C46.6607246,24.5988998,44.2126579,33.3784904,37.7143211,36.6247215
					z" />
				<path style={style.st156} d="M68.1210556,30.8566761L47.9198875,28.863512L30.5839481,18.2817249
					c-0.7329102-0.4436035-1.5981445-0.7492676-2.5083008-0.8369141c-3.2426758-0.3120117-6.1245117,2.0637207-6.4365234,5.3063965
					c-0.3120117,3.2429199,2.0634766,6.1247559,5.3061523,6.4367676l20.2172871,1.9460449L64.514122,41.6689301
					c0.7197266,0.4328613,1.5678711,0.7324219,2.4594727,0.8205566c3.2124023,0.3168945,6.0732422-2.0302734,6.3901367-5.2426758
					C73.6806259,34.0346527,71.3334579,31.1735706,68.1210556,30.8566761z" />
				<path style={style.st156} d="M46.08284,39.9521179l-3.3534584-1.1191673
					c-4.2619629-1.4223671-6.5639114-6.0304298-5.1415443-10.2923927l1.1191673-3.3534584
					c1.4223671-4.2619648,6.0304298-6.5639133,10.2923965-5.1415462l3.3534584,1.1191673
					c4.2619629,1.422369,6.5639114,6.0304298,5.1415443,10.2923946l-1.1191673,3.3534584
					C54.9528694,39.0725403,50.3448067,41.374485,46.08284,39.9521179z" />
			</g>
		);
	}
}

class TuxedoBird extends PositionedGoodyHOC {
	// 12
	render() {
		const style = {
			st155: {
				fill: '#F96E6E',
			},
			st156: {
				fill: '#F26161',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="20.509522" cy="35.2435722" r="0.2505777" />
				<path style={style.st155} d="M88.3330154,43.6074257c-2.4673615,7.1922417-6.3909378,13.9099846-9.6233597,15.5329437
					c-5.0317459,2.5135956-17.8172874-6.7758522-24.1167564-13.5642891c-1.5094185-1.624836-2.6423721-3.1015892-3.2134666-4.2452202
					c-2.9638405-5.9330482-0.5160217-14.7127209,5.9924088-17.9555817c1.2376556-0.6182671,3.020359-1.1892929,5.1256866-1.6526508
					c9.0299683-1.9976215,24.0282516-2.0931835,27.2475662,4.351284
					C91.6538849,29.8949356,90.6189041,36.9597816,88.3330154,43.6074257z" />
				<path style={style.st155} d="M37.7143211,36.6247215c-1.2376518,0.6182671-3.0201111,1.1893768-5.1254349,1.6527328
					c-9.0302143,1.9975395-24.0284977,2.0931015-27.247818-4.351368c-1.9087849-3.821022-0.8737249-10.8861141,1.4053502-17.5469799
					c2.46769-7.1924057,6.3878207-13.899806,9.6300907-15.519475c5.031744-2.513597,17.8172894,6.7758522,24.1170025,13.5643692
					c1.5094185,1.6248369,2.642128,3.1015081,3.2132225,4.2451372C46.6607246,24.5988998,44.2126579,33.3784904,37.7143211,36.6247215
					z" />
				<path style={style.st156} d="M68.1210556,30.8566761L47.9198875,28.863512L30.5839481,18.2817249
					c-0.7329102-0.4436035-1.5981445-0.7492676-2.5083008-0.8369141c-3.2426758-0.3120117-6.1245117,2.0637207-6.4365234,5.3063965
					c-0.3120117,3.2429199,2.0634766,6.1247559,5.3061523,6.4367676l20.2172871,1.9460449L64.514122,41.6689301
					c0.7197266,0.4328613,1.5678711,0.7324219,2.4594727,0.8205566c3.2124023,0.3168945,6.0732422-2.0302734,6.3901367-5.2426758
					C73.6806259,34.0346527,71.3334579,31.1735706,68.1210556,30.8566761z" />
				<path style={style.st156} d="M46.08284,39.9521179l-3.3534584-1.1191673
					c-4.2619629-1.4223671-6.5639114-6.0304298-5.1415443-10.2923927l1.1191673-3.3534584
					c1.4223671-4.2619648,6.0304298-6.5639133,10.2923965-5.1415462l3.3534584,1.1191673
					c4.2619629,1.422369,6.5639114,6.0304298,5.1415443,10.2923946l-1.1191673,3.3534584
					C54.9528694,39.0725403,50.3448067,41.374485,46.08284,39.9521179z" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	// 12
	render() {
		const style = {
			st155: {
				fill: '#F96E6E',
			},
			st156: {
				fill: '#F26161',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="28.509522" cy="40.2435722" r="0.2505777" />
				<path style={style.st155} d="M88.3330154,43.6074257c-2.4673615,7.1922417-6.3909378,13.9099846-9.6233597,15.5329437
					c-5.0317459,2.5135956-17.8172874-6.7758522-24.1167564-13.5642891c-1.5094185-1.624836-2.6423721-3.1015892-3.2134666-4.2452202
					c-2.9638405-5.9330482-0.5160217-14.7127209,5.9924088-17.9555817c1.2376556-0.6182671,3.020359-1.1892929,5.1256866-1.6526508
					c9.0299683-1.9976215,24.0282516-2.0931835,27.2475662,4.351284
					C91.6538849,29.8949356,90.6189041,36.9597816,88.3330154,43.6074257z" />
				<path style={style.st155} d="M37.7143211,36.6247215c-1.2376518,0.6182671-3.0201111,1.1893768-5.1254349,1.6527328
					c-9.0302143,1.9975395-24.0284977,2.0931015-27.247818-4.351368c-1.9087849-3.821022-0.8737249-10.8861141,1.4053502-17.5469799
					c2.46769-7.1924057,6.3878207-13.899806,9.6300907-15.519475c5.031744-2.513597,17.8172894,6.7758522,24.1170025,13.5643692
					c1.5094185,1.6248369,2.642128,3.1015081,3.2132225,4.2451372C46.6607246,24.5988998,44.2126579,33.3784904,37.7143211,36.6247215
					z" />
				<path style={style.st156} d="M68.1210556,30.8566761L47.9198875,28.863512L30.5839481,18.2817249
					c-0.7329102-0.4436035-1.5981445-0.7492676-2.5083008-0.8369141c-3.2426758-0.3120117-6.1245117,2.0637207-6.4365234,5.3063965
					c-0.3120117,3.2429199,2.0634766,6.1247559,5.3061523,6.4367676l20.2172871,1.9460449L64.514122,41.6689301
					c0.7197266,0.4328613,1.5678711,0.7324219,2.4594727,0.8205566c3.2124023,0.3168945,6.0732422-2.0302734,6.3901367-5.2426758
					C73.6806259,34.0346527,71.3334579,31.1735706,68.1210556,30.8566761z" />
				<path style={style.st156} d="M46.08284,39.9521179l-3.3534584-1.1191673
					c-4.2619629-1.4223671-6.5639114-6.0304298-5.1415443-10.2923927l1.1191673-3.3534584
					c1.4223671-4.2619648,6.0304298-6.5639133,10.2923965-5.1415462l3.3534584,1.1191673
					c4.2619629,1.422369,6.5639114,6.0304298,5.1415443,10.2923946l-1.1191673,3.3534584
					C54.9528694,39.0725403,50.3448067,41.374485,46.08284,39.9521179z" />
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	// 12
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} fill="none" cx="13.58004" cy="38.01423" />
				<path fill="#F96E6E" d="M68.31544,35.14081c-1.98579,5.78852-5.1436,11.19514-7.74514,12.50134
					c-4.04969,2.02301-14.33985-5.45339-19.40984-10.91692c-1.21482-1.30771-2.12666-2.49624-2.58629-3.41667
					c-2.38538-4.77508-0.41531-11.84121,4.82286-14.45115c0.9961-0.4976,2.43087-0.95718,4.12529-1.3301
					c7.26757-1.60774,19.3386-1.68465,21.9296,3.50203C70.98817,24.10462,70.15518,29.7906,68.31544,35.14081z"/>
				<path fill="#F96E6E" d="M27.57611,29.52094c-0.9961,0.4976-2.43067,0.95724-4.1251,1.33016
					c-7.26777,1.60768-19.3388,1.68459-21.9298-3.5021c-1.53624-3.07527-0.7032-8.76145,1.13106-14.1223
					c1.98607-5.78865,5.1411-11.18695,7.75056-12.4905c4.04969-2.02301,14.33985,5.45339,19.41003,10.91698
					c1.21482,1.30771,2.12646,2.49618,2.58609,3.4166C34.77642,19.84222,32.80615,26.90828,27.57611,29.52094z"/>
				<path fill="#F26161" d="M52.04829,24.87865L35.78983,23.2745l-13.95244-8.51651c-0.58987-0.35702-1.28623-0.60303-2.01875-0.67357
					c-2.60979-0.25112-4.92918,1.66094-5.18029,4.27073c-0.25112,2.60999,1.66074,4.92937,4.27054,5.18049l16.27143,1.56623
					l13.96502,8.47879c0.57925,0.34838,1.26186,0.58947,1.97945,0.66041c2.58543,0.25504,4.88791-1.63402,5.14296-4.21945
					C56.52279,27.43638,54.63372,25.1337,52.04829,24.87865z"/>
				<path fill="#F26161" d="M34.31133,32.19892l-2.69896-0.90074c-3.43015-1.14476-5.28282-4.85346-4.13806-8.28361l0.90074-2.69896
					c1.14476-3.43015,4.85346-5.28282,8.2836-4.13806l2.69896,0.90074c3.43015,1.14476,5.28282,4.85346,4.13806,8.28361
					l-0.90073,2.69896C41.45017,31.49101,37.74147,33.34368,34.31133,32.19892z"/>
			</g>
		);
	}
}

class Bunny extends PositionedGoodyHOC {
	// 12
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} fill="none" cx="10.58004" cy="38.01423" />
				<path fill="#F96E6E" d="M68.31544,35.14081c-1.98579,5.78852-5.1436,11.19514-7.74514,12.50134
					c-4.04969,2.02301-14.33985-5.45339-19.40984-10.91692c-1.21482-1.30771-2.12666-2.49624-2.58629-3.41667
					c-2.38538-4.77508-0.41531-11.84121,4.82286-14.45115c0.9961-0.4976,2.43087-0.95718,4.12529-1.3301
					c7.26757-1.60774,19.3386-1.68465,21.9296,3.50203C70.98817,24.10462,70.15518,29.7906,68.31544,35.14081z"/>
				<path fill="#F96E6E" d="M27.57611,29.52094c-0.9961,0.4976-2.43067,0.95724-4.1251,1.33016
					c-7.26777,1.60768-19.3388,1.68459-21.9298-3.5021c-1.53624-3.07527-0.7032-8.76145,1.13106-14.1223
					c1.98607-5.78865,5.1411-11.18695,7.75056-12.4905c4.04969-2.02301,14.33985,5.45339,19.41003,10.91698
					c1.21482,1.30771,2.12646,2.49618,2.58609,3.4166C34.77642,19.84222,32.80615,26.90828,27.57611,29.52094z"/>
				<path fill="#F26161" d="M52.04829,24.87865L35.78983,23.2745l-13.95244-8.51651c-0.58987-0.35702-1.28623-0.60303-2.01875-0.67357
					c-2.60979-0.25112-4.92918,1.66094-5.18029,4.27073c-0.25112,2.60999,1.66074,4.92937,4.27054,5.18049l16.27143,1.56623
					l13.96502,8.47879c0.57925,0.34838,1.26186,0.58947,1.97945,0.66041c2.58543,0.25504,4.88791-1.63402,5.14296-4.21945
					C56.52279,27.43638,54.63372,25.1337,52.04829,24.87865z"/>
				<path fill="#F26161" d="M34.31133,32.19892l-2.69896-0.90074c-3.43015-1.14476-5.28282-4.85346-4.13806-8.28361l0.90074-2.69896
					c1.14476-3.43015,4.85346-5.28282,8.2836-4.13806l2.69896,0.90074c3.43015,1.14476,5.28282,4.85346,4.13806,8.28361
					l-0.90073,2.69896C41.45017,31.49101,37.74147,33.34368,34.31133,32.19892z"/>
			</g>
		);
	}
}

function Bow(props) {
	const bows = {
		Cat,
		TuxedoBird,
		Tortoise,
		Chicken,
		Bunny,
	};

	const ThisBow = bows[props.petType.name] || Cat;

	if (_.isUndefined(ThisBow)) {
		return null;
	}

	return <ThisBow {...props} />;
}

export default Bow;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Bow.js